module.exports = __webpack_public_path__ + "static/media/om_hairstyle_buzz_front_vector.cf24e687.svg";